import { atom as d, map as n } from "nanostores";
const r = d(null);
function p() {
  if (window.__hydra_copilot__ != null && "copilotInstructions" in window.__hydra_copilot__)
    return window.__hydra_copilot__;
  const o = n({}), t = n({}), _ = n({}), i = {
    copilotInstructions: o,
    copilotTools: t,
    copilotContext: _,
    currentCopilotSession: r
  };
  return Object.assign(window, { __hydra_copilot__: i }), i;
}
const { copilotInstructions: e, copilotTools: s, copilotContext: c } = p();
function a(o) {
  if (!window.__hydra_copilot__)
    throw new Error("Copilot global state is not initialized.");
  Object.assign(window.__hydra_copilot__, o);
}
function w(o) {
  r.set(o);
}
function l() {
  return Math.random().toString(36).substring(2, 15);
}
function y(o) {
  const t = l();
  return e.setKey(t, o), () => {
    e.setKey(t, void 0);
  };
}
function C(o) {
  return s.setKey(o.name, o), () => {
    s.setKey(o.name, void 0);
  };
}
function f(o) {
  const t = l();
  return c.setKey(t, o), () => {
    c.setKey(t, void 0);
  };
}
export {
  f as addCopilotContext,
  y as addCopilotInstruction,
  C as addCopilotTool,
  c as copilotContext,
  e as copilotInstructions,
  s as copilotTools,
  r as currentCopilotSession,
  p as initializeGlobalState,
  a as setCopilotConfig,
  w as setCurrentSession,
  l as uniqueId
};
